import { Link, createFileRoute } from '@tanstack/react-router'
import { useSession } from '../lib/auth'
import { isFlagOn } from '../lib/posthog'
import { todayAtFacility } from '../lib/time'

export const Route = createFileRoute('/')({
  component: LandingPage,
})

function LandingPage() {
  const session = useSession()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-semibold">Golf Bay Manager</h1>
        <p className="mt-2 text-slate-600">
          Simuladores por hora, todos los días de 08:00 a 21:00.
        </p>
      </div>

      <div className="space-y-2">
        {session && (
          <p className="text-slate-600">
            Sesión iniciada como <span className="font-medium">{session.user.email}</span>.
          </p>
        )}
        {isFlagOn('customer-app') ? (
          <Link
            to="/book"
            search={{ date: todayAtFacility() }}
            className="inline-flex min-h-12 items-center rounded-md bg-slate-900 px-6 text-white hover:bg-slate-700"
          >
            Reservar un simulador
          </Link>
        ) : (
          // Says what IS true rather than hiding and leaving a blank. Somebody
          // who reaches this page while the coaches are still running the
          // schedule by hand should leave knowing how to get an hour, not
          // wondering whether the site is broken.
          <p className="text-slate-600">
            Las reservas por la web todavía no están abiertas. Por ahora los horarios se coordinan
            en el local.
          </p>
        )}
      </div>
    </div>
  )
}
